export default function Result({ num }) {
  return (
    <p>
      Found <strong>{num}</strong> Movies
    </p>
  );
}
